import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import ExpansionPanelGroup from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import React, { memo } from 'react';
import useStyles from './styles';

var Accordion = function (props) {
  var _classNames;

  var classes = useStyles(props);

  var _props$expandIcon = props.expandIcon,
      expandIcon = _props$expandIcon === void 0 ? /*#__PURE__*/React.createElement(ExpandMoreIcon, null) : _props$expandIcon,
      title = props.title,
      children = props.children,
      _props$rotateExpandIc = props.rotateExpandIcon,
      rotateExpandIcon = _props$rotateExpandIc === void 0 ? true : _props$rotateExpandIc,
      hide = props.hide,
      rest = _objectWithoutPropertiesLoose(props, ["expandIcon", "title", "children", "rotateExpandIcon", "hide"]);

  if (hide) return null;
  return /*#__PURE__*/React.createElement(ExpansionPanelGroup, _extends({
    classes: {
      root: classes.expansionPanel,
      expanded: classes.expansionPanelExpanded
    }
  }, rest), /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
    expandIcon: expandIcon,
    classes: {
      root: classes.expansionPanelSummary,
      expanded: classes.expansionPanelSummaryExpanded,
      content: classes.expansionPanelSummaryContent,
      expandIcon: classNames(classes.expansionPanelSummaryExpandIcon, (_classNames = {}, _classNames[classes.noRotate] = !rotateExpandIcon, _classNames))
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, title)), /*#__PURE__*/React.createElement(ExpansionPanelDetails, {
    className: classNames(classes.expansionPanelDetails)
  }, children));
};

Accordion.defaultProps = {
  color: 'primary'
};
export default /*#__PURE__*/memo(Accordion);